var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg5LoyaltyLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 342.31 125.94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M338.86,44.94a1.67,1.67,0,0,0,.61-1.38,1.74,1.74,0,0,0-.27-1,1.9,1.9,0,0,0-.7-.65,2.07,2.07,0,0,0-1-.24h-2.83V47.3h1.75V45.43h.2l.86,1.87h2.13l-1.3-2A2,2,0,0,0,338.86,44.94Zm-2.45-1.76H337a.89.89,0,0,1,.49.12.47.47,0,0,1,.18.42.43.43,0,0,1-.18.4.89.89,0,0,1-.49.12h-.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M341.61,41.83A5,5,0,0,0,339.72,40a6.06,6.06,0,0,0-5.5,0,4.92,4.92,0,0,0-1.89,1.84,5.81,5.81,0,0,0,0,5.49,4.87,4.87,0,0,0,1.89,1.85,6.06,6.06,0,0,0,5.5,0,4.94,4.94,0,0,0,1.89-1.85,5.73,5.73,0,0,0,0-5.49Zm-1.24,4.77A3.55,3.55,0,0,1,339,48a4.57,4.57,0,0,1-4.08,0,3.46,3.46,0,0,1-1.35-1.36,4.06,4.06,0,0,1-.49-2,4,4,0,0,1,.49-2,3.37,3.37,0,0,1,1.35-1.35,4.49,4.49,0,0,1,4.08,0,3.46,3.46,0,0,1,1.36,1.35,4.08,4.08,0,0,1,.48,2A4.16,4.16,0,0,1,340.37,46.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M140.86,63.23a13.39,13.39,0,0,0-5.28-5.4,16.53,16.53,0,0,0-8.21-1.93,18.4,18.4,0,0,0-6.16,1,11.3,11.3,0,0,0-3.33,1.83L119.21,48h21.21v-9H110.86l-3,27.15,8.49,1.57.19-.22a7.92,7.92,0,0,1,2.16-1.86,9.78,9.78,0,0,1,2.76-1.06,15.58,15.58,0,0,1,3.37-.34,9.61,9.61,0,0,1,4.29.84,5.81,5.81,0,0,1,2.55,2.45,8.44,8.44,0,0,1,.9,4.09,8.12,8.12,0,0,1-1,4.13,6.38,6.38,0,0,1-2.69,2.53,9.67,9.67,0,0,1-4.3.87A7.73,7.73,0,0,1,119,77.41a11.08,11.08,0,0,1-2.81-4.87l-.17-.58-9.87,4.94.23.45a19.62,19.62,0,0,0,7.17,8.09,20.57,20.57,0,0,0,10.77,2.65A23.42,23.42,0,0,0,131.47,87a17.59,17.59,0,0,0,5.86-3.18,14.25,14.25,0,0,0,4-5.34,18.51,18.51,0,0,0,1.4-7.41A16.39,16.39,0,0,0,140.86,63.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M156.53,61.6h13.55v6.61H147.72V39.71h8.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M184.67,39.28A15.66,15.66,0,0,1,192.29,41a12,12,0,0,1,4.88,5,17.08,17.08,0,0,1,1.7,7.91,17,17,0,0,1-1.7,7.9,11.9,11.9,0,0,1-4.88,5,17.46,17.46,0,0,1-15.24,0,11.93,11.93,0,0,1-4.94-5,16.79,16.79,0,0,1-1.73-7.9,16.83,16.83,0,0,1,1.73-7.91,12,12,0,0,1,4.94-5A15.76,15.76,0,0,1,184.67,39.28Zm0,6.73a4.61,4.61,0,0,0-2.91.89A5.32,5.32,0,0,0,180,49.51a14.12,14.12,0,0,0-.58,4.45,14.14,14.14,0,0,0,.58,4.42A5.32,5.32,0,0,0,181.76,61a5.22,5.22,0,0,0,5.8,0,5.19,5.19,0,0,0,1.73-2.64,14.82,14.82,0,0,0,.56-4.42,14.8,14.8,0,0,0-.56-4.45,5.19,5.19,0,0,0-1.73-2.61A4.63,4.63,0,0,0,184.67,46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M227.1,39.71l-10,18.39V68.21h-8.85V58.1l-10-18.39h8.93l3.45,7.12,2.12,5,2.07-5,3.5-7.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M243.93,68.21H253l-9.63-28.5H232.8l-9.59,28.5H232l1.64-5.92h8.68Zm-8.7-11.62,1.58-5.7L238,46.27h.08l1.21,4.66,1.53,5.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M263.74,61.6H277.3v6.61H254.94V39.71h8.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M299.91,39.71v6.6h-9.06v21.9H282V46.31h-9.15v-6.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M329.65,39.71l-10,18.39V68.21h-8.85V58.1l-10-18.39h8.94l3.45,7.12,2.11,5,2.08-5,3.49-7.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M31.83,16.31a2.91,2.91,0,0,0-5.32-.61,3.65,3.65,0,0,0-.37,2.63c.67,2.85,1.13,11.3,1,18.67l0,1.5c0,7.46-2.59,13-6.94,14.7l-2,.8,2,44.74a3.85,3.85,0,0,1-3.59,4.05,3.78,3.78,0,0,1-3.56-3.91l2-44.89-2-.8c-4.36-1.72-7-7.23-7-14.73-.08-6.89.35-17.06,1-20.36a3.45,3.45,0,0,0-.28-2.23,3,3,0,0,0-3-1.64,2.9,2.9,0,0,0-2.54,2.2C-.08,22.11,0,35.82,0,38.5c0,9,3.19,16,8.79,19.36L7,98.64v.14a9.88,9.88,0,0,0,9.64,10.09,9.92,9.92,0,0,0,9.63-10.22L24.42,57.86c5.59-3.3,8.77-10.28,8.78-19.3C33.2,38.41,33.66,22.7,31.83,16.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M60.91,44.65c0-18.47-12.77-31.44-19.63-31.44a5,5,0,0,0-3.94,1.69,5.75,5.75,0,0,0-1.29,3.89c0,8-.22,25.33-.23,25.85v3.08c-.1,7.17-.18,12.92,3,15.94L37,98.63v.16a9.88,9.88,0,0,0,9.64,10.09c5.31,0,9.64-4.55,9.64-10.23L54.43,64C60.39,60.21,60.91,52.38,60.91,44.65ZM50.2,59.35h0l-2,.81,2,38.58a3.85,3.85,0,0,1-3.58,4.05A3.81,3.81,0,0,1,43,98.89l2-38.58-1.83-.88c-1.46-.7-1.4-7-1.37-11.65v-4C42,30,42.08,23,42.08,19.5,45.79,21,54.82,30.18,54.82,44.65,54.83,54,53.58,58,50.2,59.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M185.78,74.69a3.87,3.87,0,0,0-3.69-.94,3.55,3.55,0,0,0-1.27.68l-.63.67-.57,1.24a56.46,56.46,0,0,1-39.8,40.42,55.6,55.6,0,1,1,33.15-83,3.62,3.62,0,0,0,3.23,1.75,3.86,3.86,0,0,0,3.25-2,3.55,3.55,0,0,0-.14-3.56A63,63,0,0,0,67.86,37.84a63.79,63.79,0,0,0,7.31,62.83,63.73,63.73,0,0,0,49.67,25.27,65.44,65.44,0,0,0,8.61-.44,63.07,63.07,0,0,0,53.34-47.27A3.65,3.65,0,0,0,185.78,74.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M162.9,85.91a2.66,2.66,0,0,0-1.13-1.17l-1.72-.3-1.38,1A39.29,39.29,0,1,1,137.87,26a44.09,44.09,0,0,1,4.6,1.77,2.33,2.33,0,0,0,3.15-1.19,2.48,2.48,0,0,0-1.23-3.32,44.22,44.22,0,1,0,15.07,69.27,45.15,45.15,0,0,0,3.24-4.2A2.4,2.4,0,0,0,162.9,85.91Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 8.4,
    y: 14.74,
    width: 4.43,
    height: 29.28,
    rx: 1.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 14.41,
    y: 14.78,
    width: 4.43,
    height: 29.28,
    rx: 1.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 20.42,
    y: 14.78,
    width: 4.43,
    height: 29.28,
    rx: 1.88
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg5LoyaltyLogo);
export default __webpack_public_path__ + "static/media/5loyalty_logo.5fc839f442f256ad5eacdf563bba014c.svg";
export { ForwardRef as ReactComponent };